/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
// import 'normalize.css';
import "typeface-inter"
import "./src/styles/global.css"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "react-dropdown/style.css"
import "lazysizes"

const checkRedirect = async (pathname) => {
  try {
    const res = await fetch('/redirects.json')
    const redirects = await res.json()

    const match = redirects.find(({ from }) => from === pathname)

    if (match && match.to !== pathname) {
      if (match.external) {
        window.location.href = match.to
      } else {
        window.location.replace(match.to)
      }
    }
  } catch (e) {
    console.warn('Redirect check failed:', e)
  }
}

export const onClientEntry = () => {
  checkRedirect(window.location.pathname)
}

export const onRouteUpdate = ({ location }) => {
  checkRedirect(location.pathname)
  const body = document.querySelector("body")
  body.classList.add("fade-in")

  setTimeout(() => {
    body.classList.remove("fade-in")
  }, 500)
}